import { Box } from '@mui/material'

interface LoadingDotsProps {
  color?: string
}

const LoadingDots = ({ color = '#0072BC' }: LoadingDotsProps) => {
  const DELAY_FOR_EACH_DOT = [ '-0.32s', '-0.16s', '0s' ]
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        '@keyframes bounce': {
          '0%, 80%, 100%': { transform: 'scale(0)' },
          '40%': { transform: 'scale(1)' },
        },
      }}
    >
      {DELAY_FOR_EACH_DOT.map((delay, index) => (
        <Box
          key={index}
          component="span"
          sx={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            backgroundColor: color,
            animation: 'bounce 1.4s infinite ease-in-out both',
            animationDelay: delay,
          }}
        />
      ))}
    </Box>
  )
}

export default LoadingDots
